"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// node_modules/is-hotkey/lib/index.js
var require_lib = __commonJS({
  "node_modules/is-hotkey/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
    var MODIFIERS = {
      alt: "altKey",
      control: "ctrlKey",
      meta: "metaKey",
      shift: "shiftKey"
    };
    var ALIASES = {
      add: "+",
      break: "pause",
      cmd: "meta",
      command: "meta",
      ctl: "control",
      ctrl: "control",
      del: "delete",
      down: "arrowdown",
      esc: "escape",
      ins: "insert",
      left: "arrowleft",
      mod: IS_MAC ? "meta" : "control",
      opt: "alt",
      option: "alt",
      return: "enter",
      right: "arrowright",
      space: " ",
      spacebar: " ",
      up: "arrowup",
      win: "meta",
      windows: "meta"
    };
    var CODES = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      control: 17,
      alt: 18,
      pause: 19,
      capslock: 20,
      escape: 27,
      " ": 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      arrowleft: 37,
      arrowup: 38,
      arrowright: 39,
      arrowdown: 40,
      insert: 45,
      delete: 46,
      meta: 91,
      numlock: 144,
      scrolllock: 145,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    };
    for (f = 1; f < 20; f++) {
      CODES["f" + f] = 111 + f;
    }
    var f;
    function isHotkey2(hotkey, options, event) {
      if (options && !("byKey" in options)) {
        event = options;
        options = null;
      }
      if (!Array.isArray(hotkey)) {
        hotkey = [hotkey];
      }
      var array = hotkey.map(function(string) {
        return parseHotkey(string, options);
      });
      var check = function check2(e) {
        return array.some(function(object) {
          return compareHotkey(object, e);
        });
      };
      var ret = event == null ? check : check(event);
      return ret;
    }
    function isCodeHotkey(hotkey, event) {
      return isHotkey2(hotkey, event);
    }
    function isKeyHotkey(hotkey, event) {
      return isHotkey2(hotkey, { byKey: true }, event);
    }
    function parseHotkey(hotkey, options) {
      var byKey = options && options.byKey;
      var ret = {};
      hotkey = hotkey.replace("++", "+add");
      var values = hotkey.split("+");
      var length = values.length;
      for (var k in MODIFIERS) {
        ret[MODIFIERS[k]] = false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;
          var optional = value.endsWith("?") && value.length > 1;
          if (optional) {
            value = value.slice(0, -1);
          }
          var name = toKeyName(value);
          var modifier = MODIFIERS[name];
          if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
            throw new TypeError('Unknown modifier: "' + value + '"');
          }
          if (length === 1 || !modifier) {
            if (byKey) {
              ret.key = name;
            } else {
              ret.which = toKeyCode(value);
            }
          }
          if (modifier) {
            ret[modifier] = optional ? null : true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return ret;
    }
    function compareHotkey(object, event) {
      for (var key in object) {
        var expected = object[key];
        var actual = void 0;
        if (expected == null) {
          continue;
        }
        if (key === "key" && event.key != null) {
          actual = event.key.toLowerCase();
        } else if (key === "which") {
          actual = expected === 91 && event.which === 93 ? 91 : event.which;
        } else {
          actual = event[key];
        }
        if (actual == null && expected === false) {
          continue;
        }
        if (actual !== expected) {
          return false;
        }
      }
      return true;
    }
    function toKeyCode(name) {
      name = toKeyName(name);
      var code = CODES[name] || name.toUpperCase().charCodeAt(0);
      return code;
    }
    function toKeyName(name) {
      name = name.toLowerCase();
      name = ALIASES[name] || name;
      return name;
    }
    exports.default = isHotkey2;
    exports.isHotkey = isHotkey2;
    exports.isCodeHotkey = isCodeHotkey;
    exports.isKeyHotkey = isKeyHotkey;
    exports.parseHotkey = parseHotkey;
    exports.compareHotkey = compareHotkey;
    exports.toKeyCode = toKeyCode;
    exports.toKeyName = toKeyName;
  }
});

// src/components/Questionnaire/index.tsx
var Questionnaire_exports = {};
__export(Questionnaire_exports, {
  Questionnaire: () => Questionnaire,
  QuestionnaireInputType: () => QuestionnaireInputType,
  questionnaireToolbarClassName: () => questionnaireToolbarClassName
});
module.exports = __toCommonJS(Questionnaire_exports);
var import_react15 = __toESM(require("react"));
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");
var import_classnames9 = __toESM(require("classnames"));

// src/components/Button/index.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}

// src/components/Questionnaire/Question.tsx
var import_react14 = __toESM(require("react"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faTrash = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
};
var faPlus = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
};

// src/components/Questionnaire/Question.tsx
var import_classnames8 = __toESM(require("classnames"));

// src/components/TextArea/index.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var defaultClassName = [
  "v2-text-sm v2-w-full v2-p-3",
  "v2-border v2-border-neutral-300 v2-rounded-md",
  "focus:v2-border-turquoise-700 hover:v2-border-turquoise-700",
  "v2-outline-none v2-resize-none"
].join(" ");
function TextArea(_a) {
  var _b = _a, {
    label,
    value = "",
    placeholder,
    rows = 1,
    maxHeight,
    inputRef,
    className,
    style
  } = _b, props = __objRest(_b, [
    "label",
    "value",
    "placeholder",
    "rows",
    "maxHeight",
    "inputRef",
    "className",
    "style"
  ]);
  var _a2;
  const textAreaRef = inputRef != null ? inputRef : (0, import_react2.useRef)(null);
  const [text, setText] = (0, import_react2.useState)(value);
  const [textAreaHeight, setTextAreaHeight] = (0, import_react2.useState)("auto");
  (0, import_react2.useEffect)(() => setTextAreaHeight("auto"), [rows]);
  (0, import_react2.useEffect)(() => {
    const scrollHeight = textAreaRef.current.scrollHeight;
    if (maxHeight && maxHeight <= scrollHeight) {
      setTextAreaHeight(`${maxHeight}px`);
      return;
    }
    const newHeight = !text && !placeholder ? "auto" : `${scrollHeight}px`;
    setTextAreaHeight(newHeight);
  }, [text, placeholder, maxHeight]);
  (0, import_react2.useEffect)(() => setText(value), [value]);
  const onChangeHandler = (event) => {
    var _a3;
    setTextAreaHeight("auto");
    setText(event.target.value);
    (_a3 = props.onChange) == null ? void 0 : _a3.call(props, event);
  };
  const isScrollbarVisible = text && maxHeight && `${maxHeight}px` === textAreaHeight;
  return /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, label, /* @__PURE__ */ import_react2.default.createElement(
    "textarea",
    __spreadProps(__spreadValues({
      className: (0, import_classnames2.default)(defaultClassName, className, {
        "v2-overflow-y-auto": isScrollbarVisible,
        "v2-scrollbar-thin scrollbar-track-neutral-200": isScrollbarVisible,
        "scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full": isScrollbarVisible,
        "v2-overflow-hidden": !isScrollbarVisible
      })
    }, props), {
      value: text,
      placeholder,
      ref: textAreaRef,
      rows,
      style: {
        height: (_a2 = style == null ? void 0 : style.height) != null ? _a2 : textAreaHeight
      },
      onChange: onChangeHandler
    })
  ));
}

// src/components/RichTextEditor/Buttons/BaseButton.tsx
var import_react3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var BaseButton = (_a) => {
  var _b = _a, {
    className,
    icon,
    active,
    onClick
  } = _b, props = __objRest(_b, [
    "className",
    "icon",
    "active",
    "onClick"
  ]);
  return /* @__PURE__ */ import_react3.default.createElement(
    "button",
    __spreadProps(__spreadValues({}, props), {
      className: (0, import_classnames3.default)(
        className,
        [
          "v2-border-0 v2-cursor-pointer v2-px-1.5 v2-flex v2-items-center",
          "hover:v2-bg-turquoise-100 v2-rounded v2-select-none v2-h-6"
        ],
        {
          "v2-bg-neutral-100": !active,
          "v2-bg-neutral-200": active,
          "v2-opacity-20": props.disabled
        }
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        onClick == null ? void 0 : onClick();
      }
    }),
    icon
  );
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var import_react13 = __toESM(require("react"));
var import_slate_react5 = require("slate-react");

// src/components/RichTextEditor/utils.ts
var import_slate3 = require("slate");

// src/components/RichTextEditor/types.ts
var TextAlignType = /* @__PURE__ */ ((TextAlignType2) => {
  TextAlignType2["Center"] = "center";
  TextAlignType2["Left"] = "left";
  TextAlignType2["Right"] = "right";
  TextAlignType2["Justify"] = "justify";
  return TextAlignType2;
})(TextAlignType || {});
var hotkeys = {
  "mod+b": "bold" /* Bold */,
  "mod+i": "italic" /* Italic */,
  "mod+u": "underline" /* Underline */
};
var listStyles = [
  "numbered-list" /* NumberedList */,
  "bulleted-list" /* BulletedList */
];

// src/components/RichTextEditor/Editor/index.tsx
var import_react12 = __toESM(require("react"));
var import_is_hotkey = __toESM(require_lib());
var import_slate_react4 = require("slate-react");
var import_classnames7 = __toESM(require("classnames"));

// src/components/RichTextEditor/Renderer/Element.tsx
var import_react4 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var OrderedList = import_styled.default.ol`
  li {
    padding-bottom: 0.75rem;
  }
`;
var Element = ({ attributes, children, element }) => {
  const style = { textAlign: element.align, color: "unset" };
  switch (element.type) {
    case "heading-one" /* HeadingOne */:
      return /* @__PURE__ */ import_react4.default.createElement(
        "h1",
        __spreadValues({
          className: "v2-text-[2rem] v2-font-normal v2-leading-10 v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "heading-two" /* HeadingTwo */:
      return /* @__PURE__ */ import_react4.default.createElement(
        "h2",
        __spreadValues({
          className: "v2-text-2xl v2-font-normal v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "bulleted-list" /* BulletedList */:
      return /* @__PURE__ */ import_react4.default.createElement(
        "ul",
        __spreadValues({
          className: "v2-list-inside v2-list-disc v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "list-item" /* ListItem */:
      return /* @__PURE__ */ import_react4.default.createElement("li", __spreadValues({ style }, attributes), children);
    case "numbered-list" /* NumberedList */:
      return /* @__PURE__ */ import_react4.default.createElement(
        OrderedList,
        __spreadValues({
          className: "v2-list-inside v2-list-decimal v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    default:
      return /* @__PURE__ */ import_react4.default.createElement(
        "p",
        __spreadValues({
          className: "v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
  }
};

// src/components/RichTextEditor/Renderer/Leaf.tsx
var import_react5 = __toESM(require("react"));
var Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = /* @__PURE__ */ import_react5.default.createElement("strong", { className: "v2-font-bold" }, children);
  }
  if (leaf.italic) {
    children = /* @__PURE__ */ import_react5.default.createElement("em", { className: "v2-italic" }, children);
  }
  if (leaf.underline) {
    children = /* @__PURE__ */ import_react5.default.createElement("u", { className: "v2-underline" }, children);
  }
  if (leaf.decoration === "link" /* Link */) {
    children = /* @__PURE__ */ import_react5.default.createElement(
      "a",
      {
        className: "v2-text-blue-400 hover:!v2-text-blue-300",
        href: leaf.text,
        target: "_blank",
        rel: "noreferrer"
      },
      children
    );
  }
  return /* @__PURE__ */ import_react5.default.createElement("span", __spreadValues({}, attributes), children);
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_react9 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/MarkButton.tsx
var import_react6 = __toESM(require("react"));
var import_slate_react = require("slate-react");
var MarkButton = ({
  className,
  type,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react.useSlate)();
  const onClickHandler = () => toggleMark(editor, type);
  return /* @__PURE__ */ import_react6.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isMarkActive(editor, type),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_classnames5 = __toESM(require("classnames"));

// src/components/RichTextEditor/Toolbar/GroupContainer.tsx
var import_react7 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
function GroupContainer({ className, children }) {
  return /* @__PURE__ */ import_react7.default.createElement(
    "div",
    {
      className: (0, import_classnames4.default)(
        className,
        "v2-flex v2-px-1.5 sm:v2-gap-x-2.5 sm:v2-px-2.5"
      )
    },
    children
  );
}

// src/components/RichTextEditor/Buttons/FormatButton.tsx
var import_react8 = __toESM(require("react"));
var import_slate_react2 = require("slate-react");
var import_slate = require("slate");
var clearBlockFormatting = (editor) => {
  import_slate.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate.Editor.isEditor(n) && import_slate.Element.isElement(n) && listStyles.includes(n.type),
    split: true
  });
  import_slate.Transforms.setNodes(editor, {
    type: "paragraph" /* Paragraph */
  });
};
var clearMarkFormatting = (editor) => {
  import_slate.Editor.removeMark(editor, "bold" /* Bold */);
  import_slate.Editor.removeMark(editor, "italic" /* Italic */);
  import_slate.Editor.removeMark(editor, "underline" /* Underline */);
};
var clearFormatting = (editor) => {
  clearBlockFormatting(editor);
  clearMarkFormatting(editor);
};
var FormatButton = ({
  className,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react2.useSlate)();
  const onClickHandler = () => clearFormatting(editor);
  return /* @__PURE__ */ import_react8.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var boldMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bold-mark.svg";
var italicMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/italic-mark.svg";
var underlineMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/underline-mark.svg";
var bulletedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bulleted-block.svg";
var numberedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/numbered-block.svg";
var headingOneBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-one-block.svg";
var headingTwoBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-two-block.svg";
var clearFormatIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/clear-format.svg";
function Toolbar({
  className,
  groupClassName,
  config,
  containerRef,
  disabled = false,
  toolbarPosition = "bottom"
}) {
  const {
    hideBold,
    hideUnderline,
    hideItalic,
    hideBulletedList,
    hideNumberedList,
    hideHeadingOne,
    hideHeadingTwo,
    hideClearFormat
  } = (0, import_react9.useMemo)(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      hideBold: (_a = config == null ? void 0 : config.hideBold) != null ? _a : false,
      hideUnderline: (_b = config == null ? void 0 : config.hideUnderline) != null ? _b : false,
      hideItalic: (_c = config == null ? void 0 : config.hideItalic) != null ? _c : false,
      hideBulletedList: (_d = config == null ? void 0 : config.hideBulletedList) != null ? _d : false,
      hideNumberedList: (_e = config == null ? void 0 : config.hideNumberedList) != null ? _e : false,
      hideHeadingOne: (_f = config == null ? void 0 : config.hideHeadingOne) != null ? _f : false,
      hideHeadingTwo: (_g = config == null ? void 0 : config.hideHeadingTwo) != null ? _g : false,
      hideClearFormat: (_h = config == null ? void 0 : config.hideClearFormat) != null ? _h : false
    };
  }, [config]);
  const headingButtons = (!hideHeadingOne || !hideHeadingTwo) && /* @__PURE__ */ import_react9.default.createElement(GroupContainer, { className: groupClassName }, !hideHeadingOne && /* @__PURE__ */ import_react9.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-one" /* HeadingOne */,
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingOneBlockIcon })
    }
  ), !hideHeadingTwo && /* @__PURE__ */ import_react9.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-two" /* HeadingTwo */,
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingTwoBlockIcon })
    }
  ));
  const formatButtons = (!hideBold || !hideItalic || !hideUnderline) && /* @__PURE__ */ import_react9.default.createElement(GroupContainer, { className: groupClassName }, !hideBold && /* @__PURE__ */ import_react9.default.createElement(
    MarkButton,
    {
      disabled,
      type: "bold" /* Bold */,
      className: "!v2-px-[7px]",
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-3 v2-w-2.5", src: boldMarkIcon })
    }
  ), !hideItalic && /* @__PURE__ */ import_react9.default.createElement(
    MarkButton,
    {
      disabled,
      type: "italic" /* Italic */,
      className: "!v2-px-2",
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-3 v2-w-2", src: italicMarkIcon })
    }
  ), !hideUnderline && /* @__PURE__ */ import_react9.default.createElement(
    MarkButton,
    {
      disabled,
      type: "underline" /* Underline */,
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-3 v2-w-3", src: underlineMarkIcon })
    }
  ));
  const listButtons = (!hideBulletedList || !hideNumberedList) && /* @__PURE__ */ import_react9.default.createElement(GroupContainer, { className: groupClassName }, !hideBulletedList && /* @__PURE__ */ import_react9.default.createElement(
    BlockButton,
    {
      disabled,
      style: "bulleted-list" /* BulletedList */,
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-4 v2-w-3", src: bulletedBlockIcon })
    }
  ), !hideNumberedList && /* @__PURE__ */ import_react9.default.createElement(
    BlockButton,
    {
      disabled,
      style: "numbered-list" /* NumberedList */,
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-4 v2-w-3", src: numberedBlockIcon })
    }
  ));
  const clearFormatButton = !hideClearFormat && /* @__PURE__ */ import_react9.default.createElement(GroupContainer, { className: groupClassName }, /* @__PURE__ */ import_react9.default.createElement(
    FormatButton,
    {
      disabled,
      className: "!v2-px-1.5 !v2-py-1",
      icon: /* @__PURE__ */ import_react9.default.createElement("img", { className: "v2-h-3 v2-w-3", src: clearFormatIcon })
    }
  ));
  const buttonComponents = (0, import_react9.useMemo)(() => {
    const components = [
      headingButtons,
      formatButtons,
      listButtons,
      clearFormatButton
    ];
    return components.filter((component) => component != false);
  }, [config]);
  return /* @__PURE__ */ import_react9.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames5.default)(className, ["v2-flex v2-py-1 v2-bg-neutral-100 v2-h-8"], {
        "v2-rounded-t-sm": toolbarPosition == "top",
        "v2-rounded-b-sm": toolbarPosition == "bottom"
      })
    },
    buttonComponents.map((child, index) => /* @__PURE__ */ import_react9.default.createElement(import_react9.default.Fragment, { key: index }, !!index && /* @__PURE__ */ import_react9.default.createElement("span", { className: "v2-h-6 v2-w-[1px] v2-bg-neutral-300" }), child))
  );
}

// src/components/RichTextEditor/Container/index.tsx
var import_react10 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
function Container(_a) {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ import_react10.default.createElement("div", __spreadValues({ className: (0, import_classnames6.default)(className, "v2-font-circular") }, props), children);
}

// src/components/RichTextEditor/use-editor-hook.ts
var import_react11 = require("react");
var import_slate2 = require("slate");
var import_slate_history = require("slate-history");
var import_slate_react3 = require("slate-react");
var useEditor = () => {
  return {
    editor: (0, import_react11.useMemo)(() => (0, import_slate_history.withHistory)((0, import_slate_react3.withReact)((0, import_slate2.createEditor)())), [])
  };
};

// src/utils/url.ts
var findUrlsInText = (text) => {
  const urlRegex = (
    // eslint-disable-next-line no-useless-escape
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim
  );
  const matches = text.match(urlRegex);
  return matches ? matches.map((m) => [m.trim(), text.indexOf(m.trim())]) : [];
};

// src/components/RichTextEditor/Editor/index.tsx
var defaultEmptyRichTextValue = [
  {
    type: "paragraph" /* Paragraph */,
    children: [
      {
        text: ""
      }
    ]
  }
];
var RichTextEditor = (_a) => {
  var _b = _a, {
    value,
    onChange,
    placeholder = "Enter some rich text\u2026",
    className,
    editorClassName,
    toolbarClassName,
    toolbarGroupClassName,
    toolbarConfig,
    toolbarPosition = "bottom",
    editor: initialEditor,
    hideToolbar = false,
    onKeyDown,
    onScrollToView,
    style
  } = _b, props = __objRest(_b, [
    "value",
    "onChange",
    "placeholder",
    "className",
    "editorClassName",
    "toolbarClassName",
    "toolbarGroupClassName",
    "toolbarConfig",
    "toolbarPosition",
    "editor",
    "hideToolbar",
    "onKeyDown",
    "onScrollToView",
    "style"
  ]);
  const { readOnly } = props;
  const toolbarRef = (0, import_react12.useRef)(null);
  const [content, setContent] = (0, import_react12.useState)(
    value != null ? value : defaultEmptyRichTextValue
  );
  const editor = initialEditor != null ? initialEditor : useEditor().editor;
  const slateDecorator = ([node, path]) => {
    const nodeText = node.text;
    if (!nodeText)
      return [];
    const urls = findUrlsInText(nodeText);
    return urls.map(([url, index]) => {
      return {
        anchor: {
          path,
          offset: index
        },
        focus: {
          path,
          offset: index + url.length
        },
        decoration: "link" /* Link */
      };
    });
  };
  const onKeyDownHandler = (event) => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    for (const hotkey in hotkeys) {
      if ((0, import_is_hotkey.default)(hotkey, event)) {
        event.preventDefault();
        const mark = hotkeys[hotkey];
        toggleMark(editor, mark);
      }
    }
  };
  (0, import_react12.useEffect)(() => {
    if (value !== null && value !== void 0) {
      editor.children = value;
      setContent(value);
    }
  }, [value]);
  const onChangeHandler = (value2) => {
    setContent(value2);
    onChange == null ? void 0 : onChange(value2);
  };
  return /* @__PURE__ */ import_react12.default.createElement(import_slate_react4.Slate, { editor, initialValue: content, onChange: onChangeHandler }, /* @__PURE__ */ import_react12.default.createElement(
    Container,
    {
      style,
      className: (0, import_classnames7.default)(
        className,
        [
          "v2-rounded v2-border v2-border-neutral-200 v2-border-solid",
          "v2-flex v2-h-full v2-w-full v2-text-neutral-900"
        ],
        {
          "v2-flex-col": toolbarPosition === "bottom",
          "v2-flex-col-reverse": toolbarPosition === "top"
        }
      )
    },
    /* @__PURE__ */ import_react12.default.createElement(
      import_slate_react4.Editable,
      __spreadProps(__spreadValues({}, props), {
        key: "rich-text-editor",
        renderElement: Element,
        renderLeaf: Leaf,
        placeholder,
        renderPlaceholder: ({ attributes, children }) => /* @__PURE__ */ import_react12.default.createElement(
          "span",
          __spreadProps(__spreadValues({}, attributes), {
            style: __spreadProps(__spreadValues({}, attributes.style), {
              display: "unset"
            })
          }),
          children
        ),
        className: (0, import_classnames7.default)(editorClassName, [
          "v2-scrollbar-thin v2-scrollbar-track-neutral-200 v2-p-2",
          "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full",
          "v2-overflow-x-hidden v2-h-full v2-w-auto v2-outline-none"
        ]),
        onKeyDown: onKeyDownHandler,
        scrollSelectionIntoView: onScrollToView,
        decorate: slateDecorator
      })
    ),
    !hideToolbar && /* @__PURE__ */ import_react12.default.createElement(
      Toolbar,
      {
        key: "rich-text-toolbar",
        containerRef: toolbarRef,
        className: toolbarClassName,
        groupClassName: toolbarGroupClassName,
        config: toolbarConfig,
        toolbarPosition,
        disabled: readOnly
      }
    )
  ));
};

// src/components/RichTextEditor/utils.ts
var checkIfTextAlignType = (style) => {
  return Object.values(TextAlignType).includes(
    style
  );
};
var isBlockActive = (editor, style, blockType = "type") => {
  const { selection } = editor;
  if (!selection)
    return false;
  const [match] = Array.from(
    import_slate3.Editor.nodes(editor, {
      at: import_slate3.Editor.unhangRange(editor, selection),
      match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && n[blockType] === style
    })
  );
  return !!match;
};
var isMarkActive = (editor, style) => {
  const marks = import_slate3.Editor.marks(editor);
  return marks ? marks[style] === true : false;
};
var toggleBlock = (editor, style) => {
  const isTextAlignType = checkIfTextAlignType(style);
  const isList = listStyles.includes(style);
  const isActive = isBlockActive(
    editor,
    style,
    isTextAlignType ? "align" : "type"
  );
  import_slate3.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && listStyles.includes(n.type) && !isTextAlignType,
    split: true
  });
  let newProperties;
  if (isTextAlignType) {
    newProperties = {
      align: isActive ? void 0 : style
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" /* Paragraph */ : isList ? "list-item" /* ListItem */ : style
    };
  }
  import_slate3.Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: style, children: [] };
    import_slate3.Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = (editor, style) => {
  const isActive = isMarkActive(editor, style);
  if (isActive) {
    import_slate3.Editor.removeMark(editor, style);
  } else {
    import_slate3.Editor.addMark(editor, style, true);
  }
};
var parseStringToRichText = (value) => {
  return value.split("\n").map((line) => {
    return {
      children: [{ text: line }]
    };
  });
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var BlockButton = ({
  className,
  style,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react5.useSlate)();
  const onClickHandler = () => toggleBlock(editor, style);
  return /* @__PURE__ */ import_react13.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isBlockActive(
        editor,
        style,
        checkIfTextAlignType(style) ? "align" : "type"
      ),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/Questionnaire/Question.tsx
var questionnaireToolbarClassName = "sm:lg:v2-px-1.5 sm:lg:v2-gap-x-0 2xl:v2-gap-x-2.5 2xl:v2-px-2.5";
function Question({
  number = 1,
  value,
  placeholder,
  onUpdate,
  onDelete,
  onFocus,
  inputType = "textarea" /* TextArea */,
  labelClassName,
  deleteButtonClassName,
  inputClassName
}) {
  const index = (0, import_react14.useMemo)(() => number - 1, [number]);
  const textAreaProps = {
    className: (0, import_classnames8.default)(inputClassName, "v2-bg-white v2-mb-3"),
    placeholder,
    onFocus: () => onFocus == null ? void 0 : onFocus(index)
  };
  const textArea = inputType === "textarea" /* TextArea */ ? /* @__PURE__ */ import_react14.default.createElement(
    TextArea,
    __spreadProps(__spreadValues({}, textAreaProps), {
      value: value != null ? value : "",
      onChange: (event) => {
        onUpdate == null ? void 0 : onUpdate({
          index,
          value: event.target.value
        });
      }
    })
  ) : /* @__PURE__ */ import_react14.default.createElement(
    RichTextEditor,
    __spreadProps(__spreadValues({}, textAreaProps), {
      editorClassName: "!v2-min-h-[75px]",
      toolbarGroupClassName: questionnaireToolbarClassName,
      value: value != null ? value : parseStringToRichText(""),
      onChange: (value2) => onUpdate == null ? void 0 : onUpdate({ index, value: value2 })
    })
  );
  return /* @__PURE__ */ import_react14.default.createElement("div", { className: "v2-flex v2-flex-col" }, /* @__PURE__ */ import_react14.default.createElement("div", { className: "v2-flex v2-justify-between v2-items-center v2-mb-3" }, /* @__PURE__ */ import_react14.default.createElement(
    "p",
    {
      className: (0, import_classnames8.default)(
        labelClassName,
        "v2-text-sm v2-text-white v2-font-bold m-0"
      )
    },
    "Question ",
    number
  ), number > 1 && /* @__PURE__ */ import_react14.default.createElement(
    import_react_fontawesome.FontAwesomeIcon,
    {
      role: "button",
      className: (0, import_classnames8.default)(
        deleteButtonClassName,
        "v2-text-white v2-text-sm hover:!v2-text-orange-600"
      ),
      icon: faTrash,
      onClick: () => onDelete == null ? void 0 : onDelete(index)
    }
  )), textArea);
}

// src/components/Questionnaire/index.tsx
var QuestionnaireInputType = /* @__PURE__ */ ((QuestionnaireInputType2) => {
  QuestionnaireInputType2["TextArea"] = "textarea";
  QuestionnaireInputType2["RichText"] = "richtext";
  return QuestionnaireInputType2;
})(QuestionnaireInputType || {});
function Questionnaire({
  data,
  maxQuestions,
  onAdd,
  onUpdate,
  onDelete,
  onFocus,
  inputType,
  labelClassName,
  deleteButtonClassName,
  addButtonClassName,
  addButtonTextClassName,
  inputClassName
}) {
  return /* @__PURE__ */ import_react15.default.createElement(import_react15.default.Fragment, null, data.map((question, index) => /* @__PURE__ */ import_react15.default.createElement(
    Question,
    __spreadValues({
      key: index,
      number: index + 1,
      onUpdate,
      onDelete,
      onFocus,
      inputType,
      labelClassName,
      deleteButtonClassName,
      inputClassName
    }, question)
  )), data.length < maxQuestions && /* @__PURE__ */ import_react15.default.createElement(
    Button,
    {
      variant: "secondary-white" /* SecondaryWhite */,
      className: (0, import_classnames9.default)(addButtonClassName, "v2-w-full"),
      onClick: onAdd
    },
    /* @__PURE__ */ import_react15.default.createElement(
      "div",
      {
        className: (0, import_classnames9.default)(
          addButtonTextClassName,
          "v2-flex v2-justify-center v2-items-center v2-gap-x-3"
        )
      },
      /* @__PURE__ */ import_react15.default.createElement(import_react_fontawesome2.FontAwesomeIcon, { className: "v2-text-2xl", icon: faPlus }),
      "Add a question"
    )
  ));
}
